<p-columnFilter
    [type]="type"
    [field]="field"
    [display]="resolvedDisplay"
    [showMenu]="showMenu"
    [hideOnClear]="hideOnClear"
    [placeholder]="placeholder"
    [ariaLabel]="ariaLabel"
    [ngClass]="isColumnFiltered() ? 'column-filter-active' : ''"
>
    <ng-content />
</p-columnFilter>
